import useTags from "./use-tags";
import createPersistedState from "use-persisted-state";
import { PersistedStorageKeys } from "constants/persisted-storage-keys";

type ISelectedTags = { [index: string]: string[] };
const useTagSelected = createPersistedState<string[]>(PersistedStorageKeys.TagSelected);
/**
 * Look through all tagIds for request, send only the tag selected if there are multiple tags
 * passed from the selected tag group and all tags from different tag groups
 * @param tagIds         Tag IDs in the URL
 * @param selectedTagIds Tag IDs that are in the table, selected by the user.
 */
const useLookupQueryTags = (tagIds: string[] | undefined): ISelectedTags => {
    const { data: allTags } = useTags();
    const [tagSelected] = useTagSelected([]);

    // Get all tag details for the passed tagIds
    const filteredTags = (allTags ?? []).filter((tag) => (tagIds ?? []).includes(tag.tagId));

    // Get selected tag details
    return tagSelected.reduce<ISelectedTags>((selectedTags, selectedTagId) => {
        const selectedTagDetails = (allTags ?? []).find(({ tagId }) => tagId === selectedTagId);

        // Find all tags in the URL with a different tag group Id to the tag selected
        // or pass all of them if there isn't any tag selected.
        const tagIdsForInteractionsCounts = (
            typeof selectedTagDetails === "undefined"
                ? filteredTags
                : filteredTags.filter((tag) => tag.tagGroupId !== selectedTagDetails.tagGroupId)
        ).map(({ tagId }) => tagId);

        // Join the tag selected with the other tags
        return {
            ...selectedTags,
            [selectedTagId]: [...tagIdsForInteractionsCounts, ...[selectedTagId]],
        };
    }, {});
};

export default useLookupQueryTags;
